var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('file-browser',{attrs:{"axios":_vm.http,"storages":_vm.storages,"endpoints":_vm.endpoints}})}
var staticRenderFns = []

export { render, staticRenderFns }